import { useState } from "react";
import { useSelector } from "react-redux";
import { FullUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/FullUserEntity";
import { UserIdentityEntity } from "../../../../../entities/ServicesEntities/UserEntities/UserIdentityEntity";
import { UserToPlatformEntity } from "../../../../../entities/ServicesEntities/UserEntities/UserToPlatformEntity";
import { UtronUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/UtronUserEntity";
import {
  ADD_PARKER_FORM_STEPS,
  UTRON_PLARFORMS
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import { userActions } from "../../../../../redux/reducers/UserReducer";
import store from "../../../../../redux/Store";
import Strings from "../../../../../resources/Strings";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import { handleGmtUserUpdateAfterUserEdit } from "../../../../../services/ParkerService";
import { removePhoneNumberPrefix, getPhoneNumberDialingCodePrefix, phoneNumberToSend } from "../../../../../utils/CommonUtils";
import {
  showErrorMessage,
  showUpdateSuccessMessage,
  showKioskLoginNameAlreadyExist,
  showEmailAlreadyExist,
  showPhoneNumberAlreadyExist
} from "../../../../../utils/MessagesUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import GeneralDetailsStep from "../Steps/GeneralDeatilsStep";
import classes from "../WizardForm.module.css";

const EditGeneralDetailsForm = (props) => {
  const selectedSites = useSelector((state) => state.user.selectedSites);
  const [formData, setFormData] = useState({
    firstName: props.firstName,
    lastName: props.lastName,
    dialingCode: getPhoneNumberDialingCodePrefix(props.phoneNumber),
    phoneNumber: removePhoneNumberPrefix(props.phoneNumber),
    originalPhoneNumber: removePhoneNumberPrefix(props.phoneNumber),
    isPhoneVerified: true,
    isCodeVerified: false,
    isVerifiedFromGmt: false,
    email: props.email,
    additionalDataId: props.utronUser?.userAdditionalData[0]?.id,
    kioskPIN: props.utronUser?.userAdditionalData[0]?.kioskPIN,
    kioskLoginName: props.utronUser?.userAdditionalData[0]?.kioskLoginName,
    notes: props.utronUser?.userAdditionalData[0]?.notes,
    isAcceptedMobileTermsAndPolicies: props.utronUser?.userAdditionalData[0]?.isAcceptedMobileTermsAndPolicies,
    isMessagingEnabled: props.utronUser?.userAdditionalData?.length > 0 && props.utronUser?.userAdditionalData[0]?.isMessagingEnabled,
    profilePicture: props.image,
    app: props.app,
    isStepSubmitted: false,
    selectedSites: selectedSites,
    fromGmt: false,
  });

  const [stateData, setStateData] = useState({
    currentStep: ADD_PARKER_FORM_STEPS.GENERAL_DETAILS,
    totalSteps: 1,
    isCurrentStepValid: false,
  });

  // added

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  // added
  const updateKioskPIN = (newKioskPin) => {
    setFormData({ ...formData, ["kioskPIN"]: newKioskPin });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const {
      email,
      firstName,
      lastName,
      dialingCode,
      phoneNumber,
      profilePicture,
      app,
      additionalDataId,
      kioskLoginName,
      kioskPIN,
      notes,
      isAcceptedMobileTermsAndPolicies,
      isMessagingEnabled
    } = formData;

    const userAdditionalData = { ...props.userAdditionalData[0] };
    userAdditionalData.id = additionalDataId;
    userAdditionalData.userId = props.utronUser?.id;
    userAdditionalData.kioskLoginName = kioskLoginName;
    userAdditionalData.kioskPIN = kioskPIN;
    userAdditionalData.notes = notes;
    userAdditionalData.isAcceptedMobileTermsAndPolicies = isAcceptedMobileTermsAndPolicies;
    userAdditionalData.isMessagingEnabled = isMessagingEnabled;
    const isMobileUser = app;
    const userPlatform = app
      ? [
        new UserToPlatformEntity(
          UTRON_PLARFORMS.MOBILE,
          props.identityId,
          UTRON_PLARFORMS.MOBILE
        ),
      ]
      : null;

    const utronUser = new UtronUserEntity(
      props.utronUser.id,
      props.identityId,
      firstName,
      lastName,
      profilePicture?.split(",")[1],
      null,
      null,
      null,
      [userAdditionalData]
    );
    const userIdentity = new UserIdentityEntity(
      props.identityId,
      email,
      email,
      dialingCode + phoneNumberToSend(dialingCode, phoneNumber),
      userPlatform
    );

    const userToUpdate = new FullUserEntity(
      utronUser,
      userIdentity,
      isMobileUser
    );


    if (stateData.isCurrentStepValid) {
      // props.phoneNumer = dialingCode + phoneNumber
      actionsService.validatePhoneNumber(props.phoneNumber, true, false)
      .then((response) => {
        // true - if phoneNumber is free to use (not found on db) or user's same phone number (phone number didnt changed) 
        if ((!response.data.isSuccess && response.data.entity === null) || props.phoneNumber === response.data.entity.userIdentity.phoneNumber) {
          actionsService.verifyIsEmailOk(formData.email, props?.utronUser?.identityId, true, false)
        .then((response) => {
          if (response.data.isSuccess && response.data.entity === true) {
            actionsService.verifyIsKioskLoginNameOk(formData.kioskLoginName, props?.utronUser?.id, true, false)
            .then((response) => {
              if (response.data.isSuccess && response.data.entity === true) {
                actionsService.updateUser(userToUpdate, true, true).then((response) => {
                  if (response.data.isSuccess) {                    
                    store.dispatch(userActions.setUpdatedParker(response.data.entity));
                    
                    handleGmtUserUpdateAfterUserEdit(props.identityId, response.data, true, false);
                    
                    showUpdateSuccessMessage();
                    store.dispatch(commonActions.closeSideModal());
                  } else {
                    //showErrorMessage(response.data?.error);
                    store.dispatch(commonActions.setIsShowLoadingSpinner(false));
                  }
                });
              }
              else {
                setFormData({ ...formData, ["isStepSubmitted"]: false });
                store.dispatch(commonActions.setIsShowLoadingSpinner(false));
                showKioskLoginNameAlreadyExist();
              }
            }).catch((error) => {
              setFormData({ ...formData, ["isStepSubmitted"]: false });
              store.dispatch(commonActions.setIsShowLoadingSpinner(false));
            });    
              }
              else {
                setFormData({ ...formData, ["isStepSubmitted"]: false });
                store.dispatch(commonActions.setIsShowLoadingSpinner(false));
                showEmailAlreadyExist();
              }
            })
            .catch((error) => {
              setFormData({ ...formData, ["isStepSubmitted"]: false });
              store.dispatch(commonActions.setIsShowLoadingSpinner(false));
            }); 
          }
          else {
            setFormData({ ...formData, ["isStepSubmitted"]: false });
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
            showPhoneNumberAlreadyExist();
          }
        })
      .catch((error) => {
        setFormData({ ...formData, ["isStepSubmitted"]: false });
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));     
      }); 
    }
  };

  return (
    <form name="EditGeneralDetails" onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <GeneralDetailsStep
          isEditMode={true}
          handleChange={handleChange}
          handleCurrentStepValidity={handleCurrentStepValidity}
          currentStep={stateData.currentStep}
          updateKioskPIN={updateKioskPIN}
          {...formData}
        />
      </div>
      {stateData.currentStep == stateData.totalSteps && (
        <div className={classes.next}>
          <EllipseButton type="submit">{Strings.SAVE_CHANGES}</EllipseButton>
        </div>
      )}
    </form>
  );
};

export default EditGeneralDetailsForm;
